import React from "react";
import CardHeader from "./common/CardHeader";
import CardSubheader from "./common/CardSubheader";
import CardPreviewImage from "./common/CardPreviewImage";
import CardFilterPills from "./common/CardFilterPills";
import CardFooter from "./common/CardFooter";
import ShortFeedItem from "../common/ShortFeedItem";
import { previewImageOfPost, mtStandardsBooks } from "../../utils/helper";

const Image = ({
  post,
  lookup,
  showPmbokModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  showShareModal,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id
}) => {
  const previewImage = previewImageOfPost(post);
  return (
    <>
      {fullcard ? (
        <div
          className={
            "flex border border-gray-500 rounded-sm mb-5 " +
            (post.status !== "Published" ? "bg-gray-400" : "bg-white")
          }
        >
          <div className="w-full">
            <CardHeader
              post={post}
              showPmbokModal={showPmbokModal}
              canProceed={canProceed}
              booksList={mtStandardsBooks(lookup, "MTStandardsGuide")}
            />

            <div className="px-5 mt-4">
              <div>
                <CardSubheader subheader={post.title} />
              </div>
              {previewImage && (
                <div>
                  <CardPreviewImage previewImage={previewImage?.filePath || previewImage} />
                </div>
              )}

              <CardFilterPills
                post={post}
                lookup={lookup}
                canProceed={canProceed}
                cardFilterSelected={cardFilterSelected}
              />
            </div>

            <CardFooter
              post={post}
              showShareModal={showShareModal}
              showFeedbackModal={showFeedbackModal}
              canProceed={canProceed}
              isAuthenticated={isAuthenticated}
              feedbackSentContentKeys={feedbackSentContentKeys}
              playlists={playlists}
              propGroup={propGroup}
              userLikes={userLikes}
              feedbacks={feedbacks}
              contentKey={contentKey}
              id={id}
            />
          </div>
        </div>
      ) : (
        <ShortFeedItem post={post} />
      )}
    </>
  );
};

export default Image;
